module.exports = __webpack_public_path__ + "static/fonts/Nunito-MediumItalic.9ec11f2.woff";